import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../../../../utils/helper';

export const unpublishedQuestionOptionsClasses = generateClasses('QuestionOptions', [
  'questionOption',
  'addAnotherOptionButton',
]);

export const Root = styled((props: StackProps) => <Stack gap={2} {...props} />)(({ theme }) => ({
  overflow: 'auto',
  [`& .${unpublishedQuestionOptionsClasses.questionOption}`]: {
    flexShrink: 0,
  },
  [`& .${unpublishedQuestionOptionsClasses.addAnotherOptionButton}`]: {
    flexShrink: 0,
  },
}));
